/** Ollama Tunnel 集成 API；Access Secret 仅提交，响应只包含掩码凭据。 */
import type { OllamaCredentialResponse, UpsertOllamaCredentialRequest } from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const ollamaApi = {
  getCredential: () =>
    apiRequest<OllamaCredentialResponse>({
      method: 'GET',
      path: '/api/v1/integrations/ollama/credential',
    }),
  upsertCredential: (body: UpsertOllamaCredentialRequest) =>
    apiRequest<OllamaCredentialResponse>({
      method: 'PUT',
      path: '/api/v1/integrations/ollama/credential',
      body,
    }),
  removeCredential: () =>
    apiRequest<{ removed: true }>({
      method: 'DELETE',
      path: '/api/v1/integrations/ollama/credential',
    }),
  testConnection: () =>
    apiRequest<{ connected: true }>({
      method: 'POST',
      path: '/api/v1/integrations/ollama/credential/test',
    }),
};
